import { SET_PHONE, SET_PHONE_DONE, SET_PHONE_ERROR, SET_PHONE_RESET, VERIFY_PHONE, VERIFY_PHONE_DONE, VERIFY_PHONE_ERROR } from './actionTypes';
export const setPhone = (data) => ({
    type: SET_PHONE,
    data
});
export const setPhoneDone = (data) => ({
    type: SET_PHONE_DONE,
    data
});
export const setPhoneError = (data) => ({
    type: SET_PHONE_ERROR,
    errorMessage: data
});
export const setPhoneReset = () => ({
    type: SET_PHONE_RESET
});
export const verifyPhone = (data) => ({
    type: VERIFY_PHONE,
    data
});
export const verifyPhoneDone = () => ({
    type: VERIFY_PHONE_DONE
});
export const verifyPhoneError = (data) => ({
    type: VERIFY_PHONE_ERROR,
    errorMessage: data
});
//# sourceMappingURL=actionCreators.js.map